// reducers/index.js
import { combineReducers } from 'redux';
import auth from './auth';
import message from './message';
import title from './title';
import page from './page';
import company from './case/company';
import plant from './case/plant';
import product from './case/product';
import role from './case/role';
import userList from './case/user';
import issueType from './case/issue_type';
import issueCategory from './case/issue_category';
import create_case from './case/create_case';
import my_case from './case/my_case';
import send_email from './send_mail';
import responsible from './case/responsible';
import my_task from './case/my_task';
import my_task_detail from './case/my_task_detail';
import productGroup from './case/product_group';
import productOwnerReport from './report/product-owner-report';
import dashboard from './case/dashboard';
import priority from './priority';
import holiday from './holiday';
import serviceType from './case/service_type';
import serviceCategory from './service_category';
import jobRole from './job_role';
import userJob from './user_job';
import serviceApproval from './case/service_approval';
import finalReviewer from './case/final_reviewer';
import finalApproval from './case/final_approval';
import estimateEffortReviewer from './case/estimate_effort_reviewer';
export default combineReducers({
    auth,
    message,
    title,
    page,
    company,
    plant,
    product,
    role,
    userList,
    issueType,
    issueCategory,
    create_case,
    my_case,
    send_email,
    responsible,
    my_task,
    my_task_detail,
    productGroup,
    productOwnerReport,
    dashboard,
    priority,
    holiday,
    serviceType,
    serviceCategory,
    jobRole,
    userJob,
    serviceApproval,
    finalReviewer,
    finalApproval,
    estimateEffortReviewer,
});
